module.exports = __webpack_public_path__ + "img/hands.6cf7fd02.png";